// Highest value Postgres can hold in the Feedback.number int4 column.
const MAX_THREAD_NUMBER = 2_147_483_647

// "#123", "123" and " #123 " all mean thread 123; anything else means the query
// is not a thread number.
export function parseThreadNumber(query: string): number | null {
	const trimmed = query.trim().replace(/^#/, "")
	if (!/^\d+$/.test(trimmed)) return null
	const parsed = Number(trimmed)
	if (parsed < 1 || parsed > MAX_THREAD_NUMBER) return null
	return parsed
}

/** The number as a customer sees it, or "" for a thread that never got one. */
export const formatThreadNumber = (number: number | null | undefined) =>
	number == null ? "" : `#${number}`
